import {
    apiRequest,
    pensiunDetail,
    pensiunApprove,
    pensiunDocuments
} from "../../../../../services/adapters/kepegawaian/pensiunService"

class ApproveRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", pensiunDetail, {
            params: query
        }, true)
    }

    fetchApprove = async (query) => {
        return await apiRequest("post", pensiunApprove, {
            params: query
        }, true)
    }

    fetchDocument = async (query) => {
        return await apiRequest("get", pensiunDocuments, {
            params: query
        }, true)
    }
}

export default ApproveRepository